import { useMutation } from 'react-query'
import { NestAPI, useGetBusiness } from '@marketing-milk/frontend'

/** Re-runs only the failed rows of a finished import. */
export const useCreativeImportRetry = () => {
  const business = useGetBusiness()

  return useMutation(async (creativeImportID: number): Promise<void> => {
    await NestAPI.post(`businesses/${business.id}/creative-import/${creativeImportID}/retry`)
  })
}
